
import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function SearchInput({ 
  onChange, 
  placeholder = "Search...", 
  className,
  ...props 
}: SearchInputProps) {
  return (
    <div className="relative w-full">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder={placeholder}
        onChange={onChange}
        className="w-full bg-background pl-8 md:w-[300px] lg:w-[400px]"
        {...props}
      />
    </div>
  );
}
